import { useMemo, type ReactNode } from "react";
import { userSeriesFirst, type EvalResultSeries } from "./evalCompareModel";
import { BoxPlotChart, boxPlotGridClass, type BoxGroup } from "./BoxPlotChart";

type DistributionPanel = {
  key: string;
  label: string;
  groups: BoxGroup[];
};

export function DistributionCompareChart({
  items,
}: {
  items: readonly EvalResultSeries[];
}): ReactNode {
  const panels = useMemo<DistributionPanel[]>(() => {
    const keys: string[] = [];
    for (const item of userSeriesFirst(items)) {
      for (const dist of item.summary.distributions) {
        if (!keys.includes(dist.key)) keys.push(dist.key);
      }
    }
    return keys
      .map((key) => {
        const groups: BoxGroup[] = items.flatMap((item) => {
          const dist = item.summary.distributions.find((candidate) => candidate.key === key);
          if (dist === undefined) return [];
          return [
            {
              key: item.key,
              label: item.label,
              color: item.color,
              stats: dist.stats,
            },
          ];
        });
        return { key, label: key, groups };
      })
      .filter((panel) => panel.groups.length > 0);
  }, [items]);

  if (panels.length === 0) return null;

  return (
    <div className={boxPlotGridClass}>
      {panels.map((panel) => (
        <BoxPlotChart key={panel.key} title={panel.label} groups={panel.groups} />
      ))}
    </div>
  );
}
